module.exports = __webpack_public_path__ + "static/img/s2model4.70e9d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model4.png
// module id = lfSN
// module chunks = 0